import {
	api
} from "./network";

export const baseImgUrl = 'https://www.vtimes.net.cn';

export const achievementApi = {
	/**
	 * 获取研发成果列表
	 * @returns {Promise<{success: boolean, scenes: Array}>}
	 */
	getAchievementList: () =>
		api.post('/save_achievements.php', {
			action: 'list'
		})
		.then(res => res.json())
};

export const bannerApi = {
	/**
	 * 获取指定导航ID的横幅图片
	 * @param {number} navId - 导航栏ID
	 * @returns {Promise<{success: boolean, banner: {image_url: string}}>}
	 */
	getBanner: (navId) =>
		api.get('/save_banner.php', {
			action: 'get_banner',
			nav_id: navId // 自动转换为 PHP 接收的下划线格式
		}).then(res => res.json())
};

export const brandStoreApi = {
	/**
	 * 查询品牌店铺
	 * @param {Object} params
	 * @param {number} [params.id] - 店铺ID（可选）
	 * @param {string} [params.city] - 所在城市（可选）
	 * @returns {Promise<{success: boolean, data: Array}>}
	 */
	getBrandStores: ({
		id,
		city
	} = {}) => {
		const params = {
			action: 'get'
		};
		if (id !== undefined && id !== null && id !== '') {
			params.id = id;
		}
		if (city !== undefined && city !== null && city !== '') {
			params.city = city;
		}
		return api.get('/save_brandstores.php', params).then(res => res.json());
	}
};

export const footerInfoApi = {
	/**
	 * 获取页脚联系信息
	 * @returns {Promise<{success: boolean, data: object}>}
	 */
	getFooterData: () =>
		api.post('/save_footerinfo.php', {
			action: 'get_data'
		}).then(res => res.json())
};

export const homeNewsApi = {
	/**
	 * 获取所有首页新闻（包含详情）
	 * @returns {Promise<{success: boolean, data: Array}>}
	 */
	getAllHomeNews: () =>
		api.post('/save_homenews.php', {
			action: 'get_all'
		}).then(res => res.json())
};

export const homeProductApi = {
	/**
	 * 获取所有首页产品（包含关联产品名称）
	 * @returns {Promise<{success: boolean, data: Array}>}
	 */
	getAllHomeProducts: () =>
		api.post('/save_homeproducts.php', {
			action: 'get_all'
		}).then(res => res.json())
};

export const newsApi = {
	/**
	 * 获取新闻列表
	 * @returns {Promise<{success: boolean, newsList: Array}>}
	 */
	getNewsList: () =>
		api.post('/save_news.php', {
			action: 'list'
		}).then(res => res.json()),

	/**
	 * 获取指定ID的新闻详情
	 * @param {number} id - 新闻ID
	 * @returns {Promise<{success: boolean, news: object}>}
	 */
	getNewsById: (id) =>
		api.get('/save_news.php', {
			action: 'get',
			id
		}).then(res => res.json())
};

export const productApi = {
	/**
	 * 获取产品列表
	 * @returns {Promise<{success: boolean, products: Array}>}
	 */
	getProductList: () =>
		api.get('/save_product.php', {
			action: 'list'
		}).then(res => res.json()),

	/**
	 * 获取指定ID的产品详情
	 * @param {number} id - 产品ID
	 * @returns {Promise<{success: boolean, product: object}>}
	 */
	getProductById: (id) =>
		api.get('/save_product.php', {
			action: 'get',
			id
		}).then(res => res.json())
};

export const sceneApi = {
	/**
	 * 获取首页智能场景列表
	 * @returns {Promise<{success: boolean, scenes: Array}>}
	 */
	getSceneList: () =>
		api.get('/save_scenes.php', {
			action: 'list'
		}).then(res => res.json())
};

export const contactApi = {
	/**
	 * 创建留言
	 * @param {Object} data - 留言数据
	 * @param {string} data.name - 姓名
	 * @param {string} data.phone - 手机号
	 * @param {string} [data.company] - 公司名称（可选）
	 * @param {string} [data.business_type] - 企业类型（可选）
	 * @param {string} data.city - 所在城市
	 * @param {string} [data.industry] - 行业品类（可选）
	 * @param {string} data.description - 需求描述
	 * @returns {Promise<{success: boolean, message: string, data: Object}>}
	 */
	createMessage: (data) =>
		api.post('/save_message.php', {
			action: 'create',
			...data
		}).then(res => res.json())
}